import React from "react";
import WLogo from "../assets/wlogo.webp";
import { Navbar, Nav, NavDropdown, Container, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Navigation.css"; // custom styles

const Navigation = () => {
    return (
        <Navbar expand="lg" className="py-3 custom-navbar border-0">
            <Container className="px-5">
                {/* Logo & Name */}
                <Navbar.Brand href="https://redcrossjalgaon.com/" className="d-flex align-items-center gap-2">
                    <img
                        src={WLogo}
                        alt="Logo"
                        width="50"
                        height="50"
                        className="d-inline-block align-top"
                    />
                    <span className="fw-bold text-dark fs-5">Indian Redcross Society</span>
                </Navbar.Brand>

                {/* Toggle for mobile */}
                <Navbar.Toggle aria-controls="basic-navbar-nav shadow-none rounded-0 border-0" />

                {/* Nav items */}
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="mx-auto nav-links">
                        <Nav.Link href="https://redcrossjalgaon.com/" className="nav-item-custom">Home</Nav.Link>
                        <Nav.Link href="https://redcrossjalgaon.com/about/" className="nav-item-custom">About</Nav.Link>

                        {/* Dropdown */}
                        <NavDropdown
                            title="Active"
                            id="active-dropdown"
                            className="nav-item-custom"
                            menuVariant="light"
                        >
                            <NavDropdown.Item href="https://redcrossjalgaon.com/new-blood/">Blood Bank</NavDropdown.Item>
                            <NavDropdown.Item href="https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Redcross%20data%2F%E0%A4%85%E0%A4%B5%E0%A4%AF%E0%A4%B5%E0%A4%A6%E0%A4%BE%E0%A4%A8%202.pdf?alt=media&token=0be897b1-3705-4022-8450-c5f5f6f7655d">Organ Donation</NavDropdown.Item>
                            <NavDropdown.Item href="https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Redcross%20data%2Feye%20donation%20article.pdf?alt=media&token=fa97fd42-eb47-4227-a716-aedf8f9095e2">Eye Donation</NavDropdown.Item>
                            <NavDropdown.Item href="https://redcrossjalgaon.com/reports/">Annual Reports</NavDropdown.Item>
                            <NavDropdown.Item href="https://redcrossjalgaon.com/documents/">Documents</NavDropdown.Item>
                            <NavDropdown.Item href="https://redcrossjalgaon.com/our-memory/">Our Memorial Memories</NavDropdown.Item>
                            <NavDropdown.Item href="https://firebasestorage.googleapis.com/v0/b/ai-search-e7e28.firebasestorage.app/o/Redcross%20data%2FOur%20Awards.pdf?alt=media&token=0c73d00f-11a2-4ace-9c35-701872d63bd6">Our Awards</NavDropdown.Item>
                        </NavDropdown>

                        <Nav.Link href="https://redcrossjalgaon.com/activity/" className="nav-item-custom">Gallery</Nav.Link>
                        <Nav.Link href="https://redcrossjalgaon.com/photo-video-gallery/" className="nav-item-custom">Gallery</Nav.Link>
                        <Nav.Link href="https://redcrossjalgaon.com/photo-video-gallery/" className="nav-item-custom">Contact</Nav.Link>
                        <Nav.Link href="/#" className="nav-item-custom active">Today's Blood Stock</Nav.Link>
                    </Nav>

                    {/* Donate Button */}
                    <Button variant="danger" className="fw-bold py-3 px-4 border-0 rounded-0">
                        DONATE
                    </Button>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Navigation;
